import api from '../../../api';
import { finish, error } from '../../../modules/staff/actions/query';

export function request(dispatch, { query, collection }) {
    const q = {
        perPage: 1000,
       ...query
    };
    api.get('/staff/search', q).then(
        data => dispatch(finish(data, collection)),
        ({ body }) => dispatch(error(body.errors, collection))
    );
}
